const LABELS: Record<string, string> = {
  support: 'Поддержка',
  tickets: 'Тикеты',
  ticket_service: 'Тикеты',
  tasks: 'Задачи',
  task_service: 'Задачи',
  leads: 'Лиды',
  lead_service: 'Лиды',
  agreements: 'Договоры',
  customers: 'Клиенты',
  payment_schedule: 'Графики платежей',
  payment_schedules: 'Графики платежей',
  user_strategies: 'Стратегии',
  telephony: 'Телефония',
  integration_service: 'Интеграции',
  smartlombard: 'SmartLombard',
  wazzup: 'Wazzup24',
  notifications: 'Уведомления',
  system: 'Система',
  auth: 'Авторизация',
};

export function notificationSourceLabel(source: string): string {
  return LABELS[source] ?? source;
}
